<template>
  <div>
    <header-mx :seccion="seccion" :subseccion="subseccion"></header-mx>
    <section class="main">
      <div class="figuras interior">
        <div class="container video">
          <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-12">
              <div class="row pt-2 pb-4 pt-lg-0">
                <div
                  class="col-12 col-lg-8 offset-lg-2 pb-4 text-center"
                  v-if="cursos != null"
                >
                  <p class="fG pb-4">
                    <strong>{{ subcurso.titulo }}</strong>
                  </p>

                  <div
                    class="row text-center pt-4 pb-5"
                    v-if="cursos[index].modelos === true"
                  >
                    <div
                      class="
                        col-6
                        text-center
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <span
                        class="etiquetagris"
                        v-html="subcurso.nombre"
                      ></span>
                    </div>
                    <div
                      class="
                        col-6
                        text-center
                        formulario
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <form>
                        <select
                          class="form-control"
                          v-model="modelo"
                          @change="changeModelo()"
                        >
                          <option value="">Cambiar modelo</option>
                          <option
                            :value="subcurso.id"
                            v-for="subcurso of cursos[index].subcursos"
                            :key="subcurso.id"
                            v-html="subcurso.nombre"
                          ></option>
                        </select>
                      </form>
                    </div>
                  </div>

                  <div class="row text-center pt-4 pb-5" v-else>
                    <div class="col-12 fG rojo bold">
                      <h2>
                        {{ cursos[index].clase }}
                      </h2>
                    </div>
                  </div>

                  <div class="fG" v-html="subcurso.descripcion"></div>

                  <div class="py-4" v-if="subcurso.fotos.length > 0">
                    <carousel-3d :controls-visible="true" :controls-prev-html="'&#10092; '" :controls-next-html="'&#10093;'">
                      <slide :index="i"  v-for="(foto, i) in subcurso.fotos" :key="i">
                        <img :src="require('../../assets/imgs/coca/'+ foto )" alt="foto adicional">
                      </slide>
                     
                    </carousel-3d>
                  </div>

                  <div class="py-4" v-if="subcurso.video != '' && subcurso.video != undefined">

                    <iframe class="videosubcurso" :src="'https://www.youtube.com/embed/'+subcurso.video" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    
                  </div>
                  

                  <div class="py-4" v-if="subcurso.video2 != '' && subcurso.video2 != undefined">

                    <iframe class="videosubcurso" :src="'https://www.youtube.com/embed/'+subcurso.video2" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    
                  </div>

                  <div class="py-4" v-if="subcurso.video3 != '' && subcurso.video3 != undefined">

                    <iframe class="videosubcurso" :src="'https://www.youtube.com/embed/'+subcurso.video3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    
                  </div>

                  <div class="py-4 row text-left">
                    <div class="col-12">
                      <div class="rojo fG bold pb-4">Recuerda:</div>
                    </div>

                    <div
                      class="col-12 checklist"
                      v-for="(check, index) of subcurso.checklist"
                      :key="index"
                    >
                      <div
                        class="
                          row
                          pb-3
                          d-flex
                          justify-content-center
                          align-items-center
                        "
                      >
                        <div class="col-1 text-right">
                          <input type="checkbox" name="" id="" />
                        </div>
                        <div class="col-10">
                          {{ check }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12" v-if="subcurso.titulochecklist2 != ''">
                      <div class="rojo fG bold pb-4">
                        {{ subcurso.titulochecklist2 }}
                      </div>
                    </div>
                    <div
                      class="col-12 checklist"
                      v-for="(check, index) of subcurso.checklist2"
                      :key="index"
                    >
                      <div
                        class="
                          row
                          pb-3
                          d-flex
                          justify-content-center
                          align-items-center
                        "
                      >
                        <div class="col-12"></div>
                        <div class="col-1 text-right">
                          <input type="checkbox" name="" id="" />
                        </div>
                        <div class="col-10">
                          {{ check }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="py-4 row text-left"
                    v-if="subcurso.levantarticket === true"
                  >
                    <div class="col-12">
                      <div class="fR">
                        <p class="pb-4" v-html="subcurso.textoticket"></p>
                        <p class="text-center">
                          <a href="#" target="_blank" class="btnsup mb-4">{{
                            subcurso.textobotonticket
                          }}</a>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="py-4 row text-left">
                    <div class="col-12">
                      <div class="card shadow p-4">
                        <span v-html="subcurso.nota"></span>
                      </div>
                    </div>
                  </div>

                  <div class="py-4 row text-center">
                    <div class="col-12">
                      <div class="p-4">
                        <span v-html="subcurso.despedida"></span>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="p-4">
                        <router-link to="/dashboard" class="btnsup"
                          >Finalizar</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-12 pb-3">
                <div class="row">
                  <div class="col-12 text-center">
                    <a
                      href="https://www.superama.com.mx/micrositio/recetas-maestros-de-la-parrilla/"
                      class="d-none d-lg-block"
                      target="_blank"
                      @click="clickComprar()"
                    >
                      <img
                        class="img-fluid"
                        src="../../assets/imgs/banner_mdlp_desk.jpg"
                        alt="recetario"
                      />
                    </a>
                    <a
                      href="https://www.superama.com.mx/micrositio/recetas-maestros-de-la-parrilla/"
                      class="d-block d-lg-none"
                      target="_blank"
                      @click="clickComprar()"
                    >
                      <img
                        class="img-fluid"
                        src="../../assets/imgs/banner_mdlp_mobile.jpg"
                        alt="recetario"
                      />
                    </a>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/HeaderInterior.vue";
import Footer from "../../Components/Footer.vue";
import Vue from "vue";
// import Vue2TouchEvents from "vue2-touch-events";
// Vue.use(Vue2TouchEvents);
import { Carousel3d, Slide } from "vue-carousel-3d";

Vue.use(Carousel3d);

export default {
  name: "AcademiaDigital",
  props: {
    msg: String,
  },
  data() {
    return {
      email: "",
      password: "",
      info: false,
      cursos: null,
      index: -1,
      seccion: "",
      subseccion: -1,
      subcurso: null,
      modelo: "",
    };
  },
  mounted: function () {
    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));
    this.initAll();
  },
  components: {
    "header-mx": Header,
    "footer-mx": Footer,
    Carousel3d,
    Slide
  },
  methods: {
    initAll() {
      this.$store.state.user = JSON.parse(
        localStorage.getItem("useracademiadigital")
      );
      AOS.init();
      this.cursos = this.$store.state.cursos;
      this.index = this.$route.params.tipo;
      this.subseccion = this.$route.params.id;

      console.log({ cursos: this.cursos });

      this.seccion = this.cursos[this.index].clase;

      for (var i = 0; i < this.cursos[this.index].subcursos.length; i++) {
        if (this.cursos[this.index].subcursos[i].id == this.subseccion) {
          this.subcurso = this.cursos[this.index].subcursos[i];
        }
      }

      console.log({ subcurso: this.subcurso });
    },
    changeModelo(id) {
      console.log(id);
      if (id != "")
        this.$router.push("/curso/" + this.index + "/" + this.modelo);
    },
    clickComprar() {
      this.$gtag.event("Click comprar", {
        event_category: "MDLP",
      });
    },
    clickRecetario() {
      this.$gtag.event("Descarga recetario", {
        event_category: "MDLP",
      });
    },
    toggleInfo() {
      this.info = !this.info;
    },
    onAfterSlideChange(index) {
      console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );
      this.index = index;
    },
    swipeHandler(direction) {
      console.log(direction); // May be left / right / top / bottom
    },
  },
  watch: {
    $route(to, from) {
      // react to route changes...

      this.initAll();
    },
  },
};
</script>

